import { AssetType, UntrackedAssetType } from '@peritasai/types';

export type TFn = (key: string) => string;

export enum AssetTab {
  Tracked = 'tracked',
  Untracked = 'untracked',
}

export interface PreferenceCardItem {
  catalogItemId: string;
  type: AssetType | UntrackedAssetType;
  name: string;
  quantity: number;
  note: string;
}
